<div class="parent">
  <gen-dynamic-form class="inner-form"
                    [formConfig]="formConfig"
                    (formChange)="onValueChange(data, $event.form)"
                    [formData]="data"
                    [formItemFullWidth]="true"
                    [formVertical]="true"
                    [disabled]="false">
  </gen-dynamic-form>
</div>
